import { render } from "./SiteFloatCard.vue?vue&type=template&id=3b6e37e6&scoped=true"
import script from "./SiteFloatCard.vue?vue&type=script&lang=js"
export * from "./SiteFloatCard.vue?vue&type=script&lang=js"

import "./SiteFloatCard.vue?vue&type=style&index=0&id=3b6e37e6&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6e37e6"]])

export default __exports__